import Link from 'next/link';
import { IconArrowRight } from '@/components/icons/IconArrowRight';
import {
    VEHICLE_IMAGE_SIZES,
    VehicleEnvkvLine,
    VehicleMedia,
    VehiclePriceBlock,
    VehicleSpecs,
    type VehicleCardModel,
} from '@/features/vehicle';
import type { HeadingLevel } from '@/lib/utils/headingLevel';

type VehicleListRowProps = {
    vehicle: VehicleCardModel;
    headingLevel?: HeadingLevel;
    eager?: boolean;
};

/** The list view: photo, facts and price side by side; stacked on small screens. */
export function VehicleListRow({ vehicle, headingLevel = 3, eager = false }: VehicleListRowProps) {
    const Heading = `h${headingLevel}` as const;

    return (
        <Link href={vehicle.href} className="vehicle-list-row">
            <VehicleMedia
                variant="list"
                image={vehicle.image}
                sizes={VEHICLE_IMAGE_SIZES.list}
                badges={vehicle.badges}
                availability={vehicle.availability}
                eager={eager}
            />

            <div className="vehicle-list-row__main">
                <div>
                    <Heading className="vehicle-list-row__title card-title">{vehicle.title}</Heading>
                    <p className="vehicle-list-row__subtitle text-sm">{vehicle.subtitle}</p>
                </div>

                <div className="vehicle-list-row__facts">
                    <VehicleSpecs specs={vehicle.specs} />
                    <VehicleEnvkvLine className="vehicle-list-row__envkv text-sm" parts={vehicle.envkvParts} />
                </div>
            </div>

            <div className="vehicle-list-row__aside">
                <VehiclePriceBlock
                    className="vehicle-list-row__price"
                    priceText={vehicle.priceText}
                    financeNote={vehicle.financeNote}
                />

                <span className="vehicle-list-row__cta label-sm">
                    Details
                    <IconArrowRight width={15} height={15} aria-hidden="true" />
                </span>
            </div>
        </Link>
    );
}
